import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { X } from "@phosphor-icons/react";

export function GenerateNudges({ hasBrandVoice, profileIncomplete, profileNudgeDismissed, onDismissNudge }) {
  return (
    <>
      {!hasBrandVoice && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[var(--accent-subtle)] border border-[#FF4400]/20 rounded-lg p-4 flex items-center justify-between gap-4"
          data-testid="brand-voice-nudge"
        >
          <div>
            <p className="text-sm font-medium text-[var(--text-primary)]">Capture your Brand Voice for better results</p>
            <p className="text-xs text-[var(--text-muted)] mt-0.5">Paste 2-3 content examples and let AI extract your unique voice. Takes 2 minutes.</p>
          </div>
          <a
            href="/settings/personalization/voice-wizard"
            className="shrink-0 px-4 py-2 rounded-md bg-[#FF4400] text-white text-xs font-semibold hover:bg-[#FF6633] transition-colors"
            data-testid="brand-voice-nudge-cta"
          >
            Capture Voice
          </a>
        </motion.div>
      )}

      {profileIncomplete && !profileNudgeDismissed && hasBrandVoice && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[var(--bg-card)] border border-amber-500/20 rounded-lg p-4 flex items-start justify-between gap-4"
          data-testid="profile-completeness-nudge"
        >
          <div className="flex-1">
            <p className="text-sm font-medium text-[var(--text-primary)]">Your content will be sharper with a complete brand profile</p>
            <p className="text-xs text-[var(--text-muted)] mt-0.5">Add your positioning, frameworks, and differentiators in Settings.</p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Link
              to="/settings"
              className="px-3 py-1.5 rounded-md bg-amber-500/10 text-amber-600 dark:text-amber-400 text-xs font-semibold hover:bg-amber-500/20 transition-colors"
              data-testid="profile-nudge-settings-link"
            >
              Complete Profile
            </Link>
            <button
              onClick={onDismissNudge}
              className="p-1 rounded text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-hover)] transition-colors"
              data-testid="profile-nudge-dismiss"
            >
              <X size={14} />
            </button>
          </div>
        </motion.div>
      )}
    </>
  );
}
